import { AppActions } from './../../shared/store/app.reducer';
import { CommonApiService } from './../../shared/services/common-api.service';
import { IState } from './../../shared/store/root.reducer';
import { User, AuthService } from './../../shared/services/auth.service';
import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { Store, select } from '@ngrx/store';
import { IApplicationLink } from 'ops-lib';
import { RequestMakerHelpers } from 'src/app/shared/helpers/request-maker.helper';

@Component({
  selector: 'app-app-navigation',
  templateUrl: './app-navigation.component.html',
  styleUrls: ['./app-navigation.component.scss']
})
export class AppNavigationComponent implements OnInit, OnDestroy {

  currentUser: User;
  currentUserSubscrption: Subscription;
  navigationSubscription: Subscription;
  navigationLinks = <Array<IApplicationLink>>{};
  appId: number;

  subscriptions: Subscription[] = [];

  constructor(
    private commonsApiService: CommonApiService,
    private authService: AuthService,
    private store: Store<IState>,
    private requestMakerHelpers: RequestMakerHelpers) { }

  ngOnInit() {
    this.subscriptions.push(this.store.pipe(select((store: IState) => store.currentUser)).subscribe(currentUser => {
      this.currentUser = currentUser;
      if (this.currentUser.id > 0) {
        this.subscriptions.push(this.store.pipe(select((store: IState) => store.app.applicationId)).subscribe(applicationId => {
          if (applicationId) {
            this.appId = applicationId;
            const params = this.requestMakerHelpers.getIRequestIdEncrypted(this.appId);
            this.commonsApiService.getNavigationBarLinks(params).subscribe(result => {
              this.navigationLinks = result;
              this.store.dispatch({
                type: AppActions.SET_NAVIGATION,
                payload: result
              });
            });
            this.commonsApiService.getApplicationsRoutes().subscribe(routes => {
              this.store.dispatch({
                type: AppActions.SET_EXTERNAL_ROUTES,
                payload: routes
              });
            });
          }
        }));
      }
    }));
  }

  redirect(navigator: any) {
    const url = String(navigator.link.url);
    const langCode = navigator.link.lang_code;

    if (langCode === 'dotnet_ng') {
      if (url && url !== '#') {
        this.authService.redirect('app-navigation', null, url)
          .subscribe(res => {
            window.open(res, '_blank');
          });
      }
    } else if (langCode === 'dotnet_js') {
      const jsUrl = url  + this.currentUser.cfid;
      window.open(
        jsUrl,
       '_blank'
       );

    } else if (langCode === 'grails') {
      this.commonsApiService.AddRedirectToken(url).subscribe(data => {
        const grailsUrl = url + 'crossAppAuth/jump?token=' + data.token;
        window.open(
          grailsUrl,
         '_blank'
         );
      });

    }
  }

  ngOnDestroy() {
    this.subscriptions.map(subscription => {
      if (subscription) {
        subscription.unsubscribe();
      }
    });
  }

}
